import React, { useContext } from 'react'
import EditProfile from './EditProfile'
import ChangePassword from './ChangePassword'
import DeleteAccount from './DeleteAccount'
import EmailNotifications from './EmailNotifications'
import AssociatesReq from './AssociatesReq'
import { Context } from 'Context/Context'
import StaffOnAttorney from './StaffOnAttorney'
import ChangeOrg from './ChangeOrg'
import ProfessionalStatistics from './ProfessionalStatistics'
import { CLIENT, FIRM, createBillingPortalSessionApi } from 'Constants'
import SubscriptionPlans from 'Components/Account/SubscriptionPlans'
import useIsMobile from 'Hooks/useIsMobile'

// Subscription tab (key 7, attorney + firm menus only): same plan cards as the
// standalone /attorney/subscription page (still used from the header), shown
// inside the profile layout so the side panel stays in place.
function SubscriptionPanel() {
    const {userDetails, makeApiCallFunc} = useContext(Context)
    const createBillingPortalSession = () => {
        makeApiCallFunc(createBillingPortalSessionApi,
            {},
            ({data}) => { window.location.href = data.url },
            (error) => console.log(error)
        )
    }
    return (
        <div className='font-plexsans'>
            <h2 style={{margin:'0 0 22px', font:"400 21px/1.3 'Spectral',serif", color:'#14213d'}}>Membership plans</h2>
            <SubscriptionPlans onSubmit={userDetails?.isActiveSubscription ? createBillingPortalSession : null}/>
        </div>
    )
}

function ProfilePageRedirect({activePanel, setActivePanel}) {
    const {userDetails} = useContext(Context)
    const isMobile = useIsMobile();
    // The client desktop layout (Profile.jsx) already pads its content area;
    // everywhere else these two tabs rendered flush against the panel edges.
    const needsPadding = !(userDetails?.role === CLIENT && !isMobile);
    const clientMobile = userDetails?.role === CLIENT && isMobile;
    const padded = (el) => needsPadding ? <div className='px-4 py-6 lg:px-10 lg:py-[34px]'>{el}</div> : el;
    const builder = () => {
        // alert(activePanel);
        switch(parseInt(activePanel))
        {
            case 0:
                console.log("activePanel", activePanel)
                // client screens have no padding of their own (the desktop layout adds it)
                return clientMobile ? padded(<EditProfile setActivePanel={setActivePanel}/>) : <EditProfile setActivePanel={setActivePanel}/>
            case 4 : 
                return (userDetails?.isUserAssistant ? <AssociatesReq/> : userDetails?.verified ? <StaffOnAttorney/> : '')
            case 1:
                return padded(<ChangePassword/>)
            case 3:
               return padded(<DeleteAccount/>)
            case 2:
               return clientMobile ? padded(<EmailNotifications/>) : <EmailNotifications/>
            case 5: 
                return ((userDetails?.isUserAssistant || userDetails?.isUserFunder) ? null : userDetails?.verified ? <ChangeOrg setActivePanel={setActivePanel}/> : '')
            case 6:
                return <ProfessionalStatistics/>
            case 7:
                // law firms can't subscribe before their profile is verified
                return ((userDetails?.isUserAssistant || (userDetails?.role === FIRM && !userDetails?.verified)) ? null : padded(<SubscriptionPanel/>))
            default:
                
                return <></>
        }
    }
  return (
    <div className='h-full w-full bg-white '>{builder()}</div>
  )
}

export default ProfilePageRedirect
